import React, { useState, useEffect } from 'react';
import { getBellSchedule, getCurrentPeriod } from '../utils/bellSchedule';

const DisplayBellSchedule = ({ scheduleType, classes }) => {
    const [currentPeriod, setCurrentPeriod] = useState(null);
    const schedule = getBellSchedule(scheduleType);
    const organization = JSON.parse(localStorage.getItem("classOrganization"));

    useEffect(() => {
        if (!schedule) return;

        const updateCurrentPeriod = () => {
            setCurrentPeriod(getCurrentPeriod(schedule));
        };

        updateCurrentPeriod();
        const interval = setInterval(updateCurrentPeriod, 60000); // Update every minute

        return () => clearInterval(interval);
    }, [schedule]);

    if (!schedule) return null;

    // Match periods to classes
    const getClassForPeriod = (periodName) => {
        if (!organization || !classes) return null;
        if (periodName === 'Lunch' || periodName === 'Collaboration') return null;

        const periodNum = periodName.replace('Period ', '');
        const periodKey = `period${periodNum}`;

        const assignedIds = organization[periodKey];
        if (!assignedIds || assignedIds.length === 0) return null;

        const classId = assignedIds[0]; // first assigned class
        const googleId = classId.replace('google-', '');

        return classes.find(c =>
            c.id === googleId || c.courseId === googleId
        );
    };

    return (
        <div className="bell-schedule-box">
            <h2>Today's Schedule</h2>
            <div className="schedule-list">
                {schedule.map((period, index) => {
                    const isCurrent = currentPeriod?.period === period.period;
                    const classInfo = getClassForPeriod(period.period);

                    return (
                        <div
                            key={index}
                            className={`period-item ${isCurrent ? 'current-period' : ''}`}
                        >
                            <div className="period-time">
                                <strong>
                                    {classInfo ? classInfo.name : period.period}
                                </strong>
                                <span>{period.start} - {period.end}</span>
                            </div>

                            {classInfo && (
                                <div className="period-class">
                                    {classInfo.room && (
                                        <span className="room">Room {classInfo.room}</span>
                                    )}
                                </div>
                            )}
                            {isCurrent && <span className="current-badge">NOW</span>} {/* this is where it displays what the current period is */}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default DisplayBellSchedule;